import axios from 'axios';

// local
// const BASE_URL = 'http://localhost:1573';

// DEV
// const BASE_URL = 'http://targettest.asktek.net/dev.target.iog.2025.webapi';
// axios.defaults.WebSocketURL = {
//   host: 'http://targettest.asktek.net',
//   path: '/dev.target.iog.2025.webapi/socket.io',
// };
// const IMAGE_BASE_URL = 'http://target.asktek.net:81/iogDevImages';

// SIT
// const BASE_URL = 'http://targettest.asktek.net/test.target.iog.2025.webapi';
// const IMAGE_BASE_URL = 'http://target.asktek.net:81/iogImages_sit';

// DEMO
// const BASE_URL = 'http://targetdemo.asktek.net/demo.target.iog.webapi';
// const IMAGE_BASE_URL = 'http://target.asktek.net:81/iogimages';

// LIVE 
const BASE_URL = 'https://live.asktek.net/iog.padma.webapi';
const IMAGE_BASE_URL = 'https://live.asktek.net:88/iogimages';

// NGINX BASED IMAGE BASE_URL

// const IMAGE_BASE_URL = `${BASE_URL}/Images`;
axios.defaults.AuditImageURL = `${IMAGE_BASE_URL}/AuditImages`;
axios.defaults.DefectImageURL = `${IMAGE_BASE_URL}/DefectImages`;
axios.defaults.MeasurementChartURL = `${IMAGE_BASE_URL}/MeasurementChart`;
axios.defaults.InspectionInfoImageURL = `${IMAGE_BASE_URL}/InspectionInfoImages`;
axios.defaults.InspectionReportURL = `${IMAGE_BASE_URL}/InspectionReport`;

axios.defaults.FabricInspectionDefectImageURL = `${IMAGE_BASE_URL}/FabricInspection/DefectImages`;
axios.defaults.FabricInspectionAuditImageURL = `${IMAGE_BASE_URL}/FabricInspection/AuditImages`;
axios.defaults.FabricInspectionImageURL = `${IMAGE_BASE_URL}/FabricInspection/InspectionImages`;



export default axios.create({
  // For Development
  baseURL: `${BASE_URL}/api`,
  headers: {
    authtoken: sessionStorage.getItem('authToken'),
  },
});
